/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { Button, Container } from '@material-ui/core';
import CreateScoringForm from 'src/components/_dashboard/scoring-model/CreateScoringForm';
import ScoringList from 'src/components/_dashboard/scoring-model/ScoringList';

import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getScoringList, getExternalModelApi } from '../../redux/slices/scoring';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function ScoringModel() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { scoringList, disableScoringList, isLoading, externalModelApi } = useSelector((state) => state.scoring);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [scoringListStatus, setScoringListStatus] = useState(true);
  const [visibleComponent, setVisibleComponent] = useState('List');
  const [currentScoringModel, setCurrentScoringModel] = useState({});

  useEffect(() => {
    dispatch(getScoringList(true));
    dispatch(getScoringList(false));
    dispatch(getExternalModelApi());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getScoringList(scoringListStatus));
  }, [scoringListStatus]);

  useEffect(() => {
    setVisibleComponent('List');
  }, []);

  useEffect(() => {
    if (editId) {
      setVisibleComponent('Edit');
      const scoringModel = scoringList.find((scoring) => scoring.id === editId);
      setCurrentScoringModel(scoringModel);
    } else setVisibleComponent('List');
  }, [editId]);

  useEffect(() => {
    if (visibleComponent !== 'Edit') setEditId('');
  }, [visibleComponent]);

  const setComponentList = (e) => {
    setVisibleComponent('List');
    e.preventDefault();
  };
  return (
    <Page title="Scoring Model | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Scoring Model"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Scoring Model',
              href: PATH_DASHBOARD.general.scoring,
              handleClick: (e) => {
                setComponentList(e);
              }
            },
            { name: `${visibleComponent} Scoring Model` }
          ]}
          action={
            visibleComponent === 'List' ? (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('Create');
                }}
                // startIcon={<Icon icon={plusFill} />}
              >
                Add Model name
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('List');
                }}
                startIcon={<Icon icon={backFill} />}
              >
                List
              </Button>
            )
          }
        />
        {visibleComponent === 'Create' && (
          <CreateScoringForm externalModelApi={externalModelApi} setVisibleComponent={setVisibleComponent} />
        )}
        {visibleComponent === 'List' && (
          <ScoringList
            scoringListStatus={scoringListStatus}
            setScoringListStatus={setScoringListStatus}
            scoringList={scoringListStatus ? scoringList : disableScoringList}
            setEditId={setEditId}
            deleteId={deleteId}
            setDeleteId={setDeleteId}
            loading={isLoading}
          />
        )}
        {visibleComponent === 'Edit' && (
          <CreateScoringForm
            externalModelApi={externalModelApi}
            editId={editId}
            setVisibleComponent={setVisibleComponent}
            currentScoringModel={currentScoringModel}
          />
        )}
      </Container>
    </Page>
  );
}
